import React, { useState, useCallback } from 'react';
import WordpressMigrationBR from '@/media/onboarding/wordpressMigration/wordpress-migration-br.png';
import WordpressMigrationES from '@/media/onboarding/wordpressMigration/wordpress-migration-es.png';
import { isBRServer } from '@/utils/Validators/validation';
import { GenericStep } from '@/components/FullWidthTemplate/GenericStep';
import { IconWordpress, Radio } from 'gatorcomponents';
import * as Styles from './ChooseMigrationOption.styles';
import { useResize } from '@/hooks/useResize';

const ChooseMigrationOption = ({
  locales, options, buttonsProps, setMigrationType,
}) => {
  const [checkedOption, setCheckedOption] = useState({});

  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 600;

  const stepProps = useCallback(() => {
    const imageSrc = isBRServer ? WordpressMigrationBR : WordpressMigrationES;
    return {
      icon: <IconWordpress color="primaryMedium" size="lg" />,
      title: locales.title,
      description: locales.description,
      imageSrc,
      buttonsProps,
    };
  }, [buttonsProps, locales]);

  const handleSelectOption = (option) => {
    setMigrationType(option.id);
    setCheckedOption(option);
  };

  return (
    <GenericStep {...stepProps()}>
      <Styles.OptionsWrapper>
        {options.map(option => option.show && (
          <Styles.ListItem key={option.id} $checked={checkedOption.id === option.id}>
            {option.tag && isMobile && <Styles.OptionTag>{option.tag}</Styles.OptionTag>}
            <Styles.RadioLabel
              data-testid={`option-${option.id}`}
              htmlFor={option.id}
              onClick={() => handleSelectOption(option)}
              role="button"
              $checked={checkedOption.id === option.id}
            >
              <Radio id={option.id} variant="blue" checked={checkedOption.id === option.id} />
              <Styles.OptionContent>
                <Styles.OptionTitle>
                  {option.title}
                  {option.tag && !isMobile && <Styles.OptionTag>{option.tag}</Styles.OptionTag>}
                </Styles.OptionTitle>

                <Styles.OptionDescription>
                  {option.description}
                </Styles.OptionDescription>
              </Styles.OptionContent>
            </Styles.RadioLabel>
          </Styles.ListItem>
        ))}
      </Styles.OptionsWrapper>
    </GenericStep>
  );
};

export default ChooseMigrationOption;
